import { useCallback, useMemo } from "react";

import { CalloutRefresh, CityAreasForm } from "../components";
import { useCities, useUser } from "../services";
import { LoadingScreen } from "./loading";

export function CityAreasScreen() {
  // Data
  const {
    data: cities,
    isLoading: isCitiesLoading,
    refetch: refetchCities,
  } = useCities();
  const {
    data: user,
    isLoading: isUserLoading,
    refetch: refetchUser,
  } = useUser();

  // Vars
  const city = useMemo(() => {
    return cities?.find((_city) => _city.id === user?.city?.id) ?? null;
  }, [cities, user]);

  // Methods
  const refresh = useCallback(() => {
    refetchUser();
    refetchCities();
  }, [refetchUser, refetchCities]);

  // Handlers
  const handleSuccess = useCallback(() => {
    alert("City areas updated successfully!");
  }, []);

  // Render
  if (isUserLoading || isCitiesLoading) {
    return <LoadingScreen />;
  }

  if (!user || !city) {
    return <CalloutRefresh onRefresh={refresh} />;
  }

  return <CityAreasForm city={city} onSuccess={handleSuccess} user={user} />;
}
